import { useInfiniteQuery, type InfiniteData, type UseInfiniteQueryResult } from '@tanstack/react-query';
import { fetchControlItgcRiskOptionsPage } from '../../request/controls/controlItgcOptions.ts';

export const controlItgcRiskOptionsQueryKey = (domainId: string, search: string) =>
  ['controls', 'itgc-risk-options', domainId, search] as const;

export type ControlItgcRiskOptionsPageView = Awaited<ReturnType<typeof fetchControlItgcRiskOptionsPage>>;

export function useControlItgcRiskOptions(
  domainId: string,
  search: string,
  enabled = true
): UseInfiniteQueryResult<InfiniteData<ControlItgcRiskOptionsPageView>, Error> {
  const normalizedDomainId = String(domainId ?? '').trim();
  return useInfiniteQuery({
    queryKey: controlItgcRiskOptionsQueryKey(normalizedDomainId, search),
    enabled: enabled && Boolean(normalizedDomainId),
    staleTime: 0,
    refetchOnMount: 'always',
    initialPageParam: 1,
    queryFn: ({ pageParam }) =>
      fetchControlItgcRiskOptionsPage({
        page: Number(pageParam) || 1,
        pageSize: 20,
        search,
        domainId: normalizedDomainId,
      }),
    getNextPageParam: (lastPage) => {
      const items = lastPage.items;
      if (!Array.isArray(items) || items.length === 0) return undefined;
      const pageSize = lastPage.pageSize || 20;
      if (lastPage.isLastPage === true) return undefined;
      if (lastPage.isLastPage == null && items.length < pageSize) return undefined;
      const page = typeof lastPage.page === 'number' && Number.isFinite(lastPage.page) ? lastPage.page : 1;
      return page + 1;
    },
  });
}
